/**
 * FASE 1 — Nacionalidade (país) e Naturalidade (cidade/UF).
 *
 * Decisão de projeto: a nacionalidade é **texto com sugestões**, não uma lista
 * fechada. Motivo: o cadastro não pode barrar atleta estrangeiro nem obrigar o
 * usuário a achar o país numa lista de 200 itens; mas a lista de sugestões deixa
 * a grafia padronizada (quem escolhe "Brasil" grava "Brasil").
 *
 * `normalizarPais` só CANONIZA o que já está na lista (ignorando acento e
 * maiúsculas); qualquer outro texto é mantido como o usuário escreveu.
 */

/** Sugestão padrão de nacionalidade em cadastro novo. */
export const NACIONALIDADE_PADRAO = 'Brasil';

/** Países em português (sugestões do campo; não é lista fechada). */
export const PAISES = [
  'Afeganistão', 'África do Sul', 'Albânia', 'Alemanha', 'Andorra', 'Angola',
  'Antígua e Barbuda', 'Arábia Saudita', 'Argélia', 'Argentina', 'Armênia',
  'Austrália', 'Áustria', 'Azerbaijão', 'Bahamas', 'Bangladesh', 'Barbados',
  'Barein', 'Bélgica', 'Belize', 'Benin', 'Bielorrússia', 'Bolívia',
  'Bósnia e Herzegovina', 'Botsuana', 'Brasil', 'Brunei', 'Bulgária',
  'Burquina Faso', 'Burundi', 'Butão', 'Cabo Verde', 'Camarões', 'Camboja',
  'Canadá', 'Catar', 'Cazaquistão', 'Chade', 'Chile', 'China', 'Chipre',
  'Cingapura', 'Colômbia', 'Comores', 'Congo', 'Coreia do Norte',
  'Coreia do Sul', 'Costa do Marfim', 'Costa Rica', 'Croácia', 'Cuba',
  'Dinamarca', 'Djibuti', 'Dominica', 'Egito', 'El Salvador',
  'Emirados Árabes Unidos', 'Equador', 'Eritreia', 'Eslováquia', 'Eslovênia',
  'Espanha', 'Estados Unidos', 'Estônia', 'Eswatini', 'Etiópia', 'Fiji',
  'Filipinas', 'Finlândia', 'França', 'Gabão', 'Gâmbia', 'Gana', 'Geórgia',
  'Granada', 'Grécia', 'Guatemala', 'Guiana', 'Guiné', 'Guiné-Bissau',
  'Guiné Equatorial', 'Haiti', 'Holanda', 'Honduras', 'Hungria', 'Iêmen',
  'Ilhas Marshall', 'Ilhas Salomão', 'Índia', 'Indonésia', 'Irã', 'Iraque',
  'Irlanda', 'Islândia', 'Israel', 'Itália', 'Jamaica', 'Japão', 'Jordânia',
  'Kiribati', 'Kosovo', 'Kuwait', 'Laos', 'Lesoto', 'Letônia', 'Líbano',
  'Libéria', 'Líbia', 'Liechtenstein', 'Lituânia', 'Luxemburgo', 'Macedônia do Norte',
  'Madagascar', 'Malásia', 'Malaui', 'Maldivas', 'Mali', 'Malta', 'Marrocos',
  'Maurício', 'Mauritânia', 'México', 'Mianmar', 'Micronésia', 'Moçambique',
  'Moldávia', 'Mônaco', 'Mongólia', 'Montenegro', 'Namíbia', 'Nauru', 'Nepal',
  'Nicarágua', 'Níger', 'Nigéria', 'Noruega', 'Nova Zelândia', 'Omã',
  'Palau', 'Palestina', 'Panamá', 'Papua-Nova Guiné', 'Paquistão', 'Paraguai',
  'Peru', 'Polônia', 'Portugal', 'Quênia', 'Quirguistão', 'Reino Unido',
  'República Centro-Africana', 'República Democrática do Congo',
  'República Dominicana', 'República Tcheca', 'Romênia', 'Ruanda', 'Rússia',
  'Samoa', 'San Marino', 'Santa Lúcia', 'São Cristóvão e Névis',
  'São Tomé e Príncipe', 'São Vicente e Granadinas', 'Seicheles', 'Senegal',
  'Serra Leoa', 'Sérvia', 'Síria', 'Somália', 'Sri Lanka', 'Sudão',
  'Sudão do Sul', 'Suécia', 'Suíça', 'Suriname', 'Tailândia', 'Tajiquistão',
  'Tanzânia', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad e Tobago', 'Tunísia',
  'Turcomenistão', 'Turquia', 'Tuvalu', 'Ucrânia', 'Uganda', 'Uruguai',
  'Uzbequistão', 'Vanuatu', 'Vaticano', 'Venezuela', 'Vietnã', 'Zâmbia',
  'Zimbábue',
];

/** Compara sem acento e sem maiúscula (para achar o país na lista). */
const chave = (texto) => String(texto ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

/**
 * Canoniza a nacionalidade QUANDO ela já está na lista ("brasil" → "Brasil");
 * qualquer outro texto volta só com os espaços normalizados.
 */
export function normalizarPais(valor) {
  const texto = String(valor ?? '').replace(/\s+/g, ' ').trim();
  if (!texto) return '';
  const achado = PAISES.find((p) => chave(p) === chave(texto));
  return achado || texto;
}

/** Naturalidade no padrão da ficha: "Cidade/UF" (texto livre, limpo). */
export function normalizarNaturalidade(valor) {
  return String(valor ?? '').replace(/\s+/g, ' ').trim().slice(0, 80);
}
